<template>
  <div class="stripe-wallet-widget-page">
    <div class="app-content-page">
      <app-stripe-wallet-widget-filter />
      <app-stripe-wallet-widget />
    </div>
  </div>
</template>

<script>
import StripeWalletListFilter from '@modules/stripe/stripe-wallet/components/stripe-wallet-widget-filter.vue';
import StripeWalletListTable from '@modules/stripe/stripe-wallet/components/stripe-wallet-widget.vue';

export default {
  name: 'app-stripe-wallet-widget-page',

  components: {
    [StripeWalletListFilter.name]: StripeWalletListFilter,
    [StripeWalletListTable.name]: StripeWalletListTable,
  },
};
</script>
